var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11682",
    "data-name": "Group 11682",
    transform: "translate(-908 -496)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(908 496)",
    fill: "#c3cad8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-image",
    "data-name": "Icon material-image",
    d: "M16.213,14.911V5.8a1.305,1.305,0,0,0-1.3-1.3H5.8A1.305,1.305,0,0,0,4.5,5.8v9.11a1.305,1.305,0,0,0,1.3,1.3h9.11A1.305,1.305,0,0,0,16.213,14.911ZM8.079,11.333l1.627,1.959,2.278-2.935,2.928,3.9H5.8Z",
    transform: "translate(912.644 500.644)",
    fill: "#2c3a56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCover);
export default __webpack_public_path__ + "static/media/UploadCover.4883af3e0be3cb302ee6cdb56b341ddc.svg";
export { ForwardRef as ReactComponent };